var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.429,
    height: 126.425,
    viewBox: "0 0 126.429 126.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_1_",
    "data-name": "edit (1)",
    transform: "translate(2.5 1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M96.131,126.293a5.058,5.058,0,0,0-5.059,5.059v40.477a5.065,5.065,0,0,1-5.059,5.059H15.179a5.064,5.064,0,0,1-5.059-5.059V100.995a5.064,5.064,0,0,1,5.059-5.059H55.655a5.06,5.06,0,0,0,0-10.119H15.179A15.2,15.2,0,0,0,0,100.995v70.834a15.2,15.2,0,0,0,15.179,15.179H86.013a15.2,15.2,0,0,0,15.179-15.179V131.352a5.055,5.055,0,0,0-5.06-5.059Zm0,0",
    transform: "translate(0 -65.081)",
    fill: "#228caa",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M186.128,108.293a2.56,2.56,0,0,0-.693,1.29l-3.577,17.891a2.528,2.528,0,0,0,2.485,3.025,2.407,2.407,0,0,0,.5-.05l17.886-3.577a2.519,2.519,0,0,0,1.3-.694L244.05,86.147,226.164,68.262Zm0,0",
    transform: "translate(-138.69 -51.69)",
    fill: "#3eaa22",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M416.333,4.2a12.657,12.657,0,0,0-17.886,0l-7,7,17.886,17.886,7-7a12.647,12.647,0,0,0,0-17.885Zm0,0",
    transform: "translate(-298.608)",
    fill: "#3eaa22",
    stroke: "#fff",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.4b75ccbb0b177e658d7b10a762843904.svg";
export { ForwardRef as ReactComponent };